var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCryptoInputCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M17.1298 4.84615L17.1538 3.69231C17.1518 2.97889 16.8675 2.29527 16.363 1.7908C15.8586 1.28633 15.175 1.00203 14.4615 1H4.07692C3.26161 1.00241 2.48039 1.32736 1.90387 1.90387C1.32736 2.48039 1.00241 3.26161 1 4.07692V14.4615C1.00203 15.175 1.28633 15.8586 1.7908 16.363C2.29527 16.8675 2.97889 17.1518 3.69231 17.1538H4.84615",
    stroke: "#000",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M18.2597 4.8457H7.58658C6.0731 4.8457 4.84619 6.07262 4.84619 7.58609V18.2592C4.84619 19.7726 6.0731 20.9995 7.58658 20.9995H18.2597C19.7731 20.9995 21 19.7726 21 18.2592V7.58609C21 6.07262 19.7731 4.8457 18.2597 4.8457Z",
    stroke: "#000",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCryptoInputCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crypto-input-copy.58e2a5f929975e696c457486b86161fd.svg";